import { artBoardActions } from '@store/reducers/artboard'
import {
  PROJECT_HISTORY_ROLLBACK_TO_BACKUP_SNAPSHOT,
  PROJECT_HISTORY_SAVE_BACKUP_SNAPSHOT,
} from '@store/reducers/manager/middleware/history/types'

import * as ActionTypes from './actions'

export const saveBackupSnapshot = () => ({
  type: PROJECT_HISTORY_SAVE_BACKUP_SNAPSHOT,
})

export const rollbackToBackupSnapshot = () => ({
  type: PROJECT_HISTORY_ROLLBACK_TO_BACKUP_SNAPSHOT,
})

export const setCursorGrabMode = () => artBoardActions.setCursorMode('grab')

export const setCursorSelectMode = () => artBoardActions.setCursorMode('select')

// todo: add payload type, move to special saga
export const commitProjectRequest = (...payload: any[]) => ({
  type: ActionTypes.COMMIT_PROJECT_REQUEST,
  payload,
})

// pure commit, without dispatch locally
export const commitProjectRequestPure = (...payload: any[]) => ({
  type: ActionTypes.COMMIT_PROJECT_REQUEST_PURE,
  payload,
})
